import AppHeader from '@components/AppNavigation/AppHeader';
import { ActionsFooter, ApprovalDialogButton } from '@components/Forms';
import { LoadingButton } from '@mui/lab';
import { Box, Grid } from '@mui/material';
import { onSubmitForm } from '@utils/forms';
import { useFormik } from 'formik';
import { useToast } from 'hooks';
import React, { FC } from 'react';
import { ITOTPSettings } from 'types/settings';
import AuthMethodSwitch from './AuthMethodSwitch';

interface ITOTPProps {
	settings?: ITOTPSettings;
	onSave: (data: ITOTPSettings) => Promise<ITOTPSettings>;
}

const DEFAULT_FORM: ITOTPSettings = {
	id: '',
	version: 0,
	enabled: false
};

const TOTPPage: FC<ITOTPProps> = ({ onSave, settings }) => {
	const { addToast } = useToast();

	const formik = useFormik<ITOTPSettings>({
		enableReinitialize: true,
		initialValues: {
			...DEFAULT_FORM,
			...settings
		},
		onSubmit: onSubmitForm<ITOTPSettings>(onSave, addToast)
	});

	return (
		<Box
			display="flex"
			flexDirection="column"
			flexGrow={1}
			overflow="hidden"
			data-testid="authentication-methods-totp"
		>
			<AppHeader translation="pages.authMethods.totp.title" mb={0} />

			<Box display="flex" flexDirection="column" flexGrow={1} component="form">
				<Grid item pl={4}>
					<AuthMethodSwitch formik={formik} />
				</Grid>
				<Grid flexGrow={1} />
				<ActionsFooter>
					<LoadingButton
						color="primary"
						variant="contained"
						onClick={() => formik.handleSubmit()}
						loading={formik.isSubmitting}
						disabled={!formik.dirty}
						sx={{ marginRight: 1 }}
					>
						{intl.tr('button.save')}
					</LoadingButton>
					<ApprovalDialogButton
						buttonText={intl.tr('button.cancel')}
						onApprove={formik.resetForm}
						disabled={!formik.dirty}
						title={intl.tr('discard.changes.dialog.title')}
						question={intl.tr('discard.changes.dialog.question')}
						approveText={intl.tr('discard.changes.dialog.approve')}
					/>
				</ActionsFooter>
			</Box>
		</Box>
	);
};

TOTPPage.defaultProps = {
	settings: DEFAULT_FORM
};

export default TOTPPage;
